import {TopLevelDomain} from '../types';

import {
    useCreateTopLevelDomainMutation,
    useDeleteTopLevelDomainMutation,
    useTopLevelDomainQuery,
    useUpdateTopLevelDomainMutation,
} from './useTopLevelDomainsQuery';

// FNP-944: the single record comes from React Query. Return shape unchanged so
// the pages and forms consuming this hook did not change.
export const useTopLevelDomain = (topLevelDomainId?: string) => {

    const {
        data: record,
        isLoading,
        refetch
    } = useTopLevelDomainQuery(topLevelDomainId);

    const createMutation = useCreateTopLevelDomainMutation();
    const updateMutation = useUpdateTopLevelDomainMutation();
    const deleteMutation = useDeleteTopLevelDomainMutation();

    // FETCH
    const fetchRecord = () => {
        if (typeof topLevelDomainId === 'undefined') {
            throw new Error('topLevelDomainId is required parameter');
        }
        refetch();
    };

    // CREATE, UPDATE, DELETE
    const createRecord = (values: TopLevelDomain) => {
        createMutation.mutate(values);
    };

    const updateRecord = (values: TopLevelDomain) => {
        if (typeof topLevelDomainId === 'undefined') {
            throw new Error('topLevelDomainId is required parameter');
        }
        updateMutation.mutate({
            id: topLevelDomainId,
            record: values,
        });
    };

    const deleteRecord = () => {
        if (typeof topLevelDomainId === 'undefined') {
            throw new Error('topLevelDomainId is required parameter');
        }
        deleteMutation.mutate(topLevelDomainId);
    };

    return {
        record,
        loading: isLoading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
